import { createContext, useContext, useEffect, useState } from "react";
import { fetchMyAccount } from "../api/accountApi";

// The signed-in login's account: { agencyId, name, role, showAdtao, maxPostcodes, features }.
// App.js loads it once per sign-in and shares it with every screen through
// AccountContext; screens read it with useAccount().
export const AccountContext = createContext(null);

export function useAccount() {
  return useContext(AccountContext);
}

// { account, accountLoading } for the session's login. account is null when
// signed out or when the login isn't linked to an account.
export default function useMyAccount(session) {
  const userId = session && session.user ? session.user.id : null;
  const [loaded, setLoaded] = useState({ userId: null, account: null });

  useEffect(() => {
    if (!userId) return undefined;
    let cancelled = false;
    fetchMyAccount(userId).then(account => {
      if (!cancelled) setLoaded({ userId, account });
    });
    return () => { cancelled = true; };
  }, [userId]);

  const ready = Boolean(userId) && loaded.userId === userId;
  return { account: ready ? loaded.account : null, accountLoading: Boolean(userId) && !ready };
}
